import { render, staticRenderFns } from "./transferAdministrator.vue?vue&type=template&id=4b36ed42&scoped=true&"
import script from "./transferAdministrator.vue?vue&type=script&lang=js&"
export * from "./transferAdministrator.vue?vue&type=script&lang=js&"
import style0 from "./transferAdministrator.vue?vue&type=style&index=0&id=4b36ed42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b36ed42",
  null
  
)

export default component.exports